export default __webpack_public_path__ + "media/images/images/icons/video-play-a2cad686d3a4611950e7ee449ab5d0ab.svg";